
import { DisenioPaginas } from '../../layout';
import { FormCreateUpdateProducto } from '../../components';



export const CrearProducto = () => {


    const initialState = {
        nombre: '',
        precioSin: '',
        proveedor: [],
        categoria: '',
        detalles: '',
        unidadMedida: '',
        iva: '',
    };


    return (
        
        <DisenioPaginas titulo="Crear Producto" url={1} add={false} subtitulo="Información de producto">
            <FormCreateUpdateProducto initialState={initialState} />
        </DisenioPaginas>
    

    )
}
